import { render, staticRenderFns } from "./OrderDetailTabs.vue?vue&type=template&id=58f5b2d9&scoped=true"
import script from "./OrderDetailTabs.vue?vue&type=script&lang=js"
export * from "./OrderDetailTabs.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailTabs.vue?vue&type=style&index=0&id=58f5b2d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5b2d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
